export namespace LocalStorageServiceConfig {
  export interface IHistoryItem {
    type?: HistoryItemTypes,
    title?: string;
    image?: string;
    keyword?: {
      entity_id: string;
      keyword: string;
    }
    id?: string;
  }

  export enum HistoryItemTypes {
    FILM = 'film',
    KEYWORD = 'keyword',
  }
}
